<script lang="ts">
  import { Edit, XCircle } from "svelte-feathers"
  import {
    Milestone,
    isFixed,
    formatPercentage,
    formatDate,
    isSolePersistedPercentageMilestone,
    LateRegistrantPaymentStrategy,
  } from "@models/milestones/Milestone"
  import { Package } from "@models/trips/Package"
  import { formatCentsAsUsd } from "@util/money"
  import { del } from "@util/api"
  import { createErrorNotice, GENERIC_ERROR_MESSAGE } from "@util/notices"
  import MilestoneTooltip from "./MilestoneTooltip.svelte"
  import MilestoneLabel from "./MilestoneLabel.svelte"
  export let milestone: Milestone
  export let milestones: Milestone[]
  export let packages: Package[]
  export let path: string
  export let readOnly: boolean
  export let lateRegistrantPaymentStrategy: LateRegistrantPaymentStrategy = "catch_up"
  export let index: number = 0

  function toggleEditStatus() {
    milestone.isEditing = !milestone.isEditing
  }

  async function deleteMilestone() {
    if (confirm("Are you sure you want to delete this payment?") === true) {
      let result = await del(path)

      if (result.ok) {
        milestones = milestones.filter((ms) => ms.id !== milestone.id)
      }

      return result
    }
  }

  $: hideDelete = isSolePersistedPercentageMilestone(milestones, milestone)
</script>

<div data-role={`milestone-preview-${milestone.id}`} class="portrait_mobile:flex justify-between px-4 py-1">
  <div class="portrait_mobile:w-1/4" data-role="milestone-label">
    <MilestoneLabel {milestones} {milestone} />
  </div>
  <div class="portrait_mobile:text-center">
    {#if isFixed(milestone)}
      {formatCentsAsUsd(milestone.amount)}
    {:else}
      <span class="flex group">
        {formatPercentage(milestones)}%
        <MilestoneTooltip {milestones} {milestone} {packages} />
      </span>
    {/if}
  </div>
  <div class="portrait_mobile:text-center">
    <span>{formatDate(milestone)}</span>
  </div>
  {#if readOnly === false}
    <div class="flex space-x-2 portrait_mobile:justify-end">
      <a href={"#"} class="svg-icon-s" data-role="edit" on:click={toggleEditStatus}>
        <Edit size="16" strokeWidth={2.0} class="ml-1" />
      </a>
      {#if hideDelete}
        <div class="w-5" />
      {:else}
        <a
          href={"#"}
          class="text-red-700 svg-icon-s"
          data-role="delete"
          on:click={async () => {
            await deleteMilestone()
          }}>
          <XCircle size="16" strokeWidth={2.0} class="ml-1" />
        </a>
      {/if}
    </div>
  {/if}
</div>
